import { useEffect } from 'react';

interface BlogListItem {
    title: string;
    slug: string;
    image: string;
    datePublished: string;
}

const BASE_URL = 'https://antz.ai';

export function useBlogListJsonLd(posts: BlogListItem[]) {
    useEffect(() => {
        const jsonLd = {
            '@context': 'https://schema.org',
            '@type': 'CollectionPage',
            name: 'The Ant-thology — Antz AI Blog',
            description:
                'Insights on manufacturing intelligence, agentic AI, and enterprise automation from the Antz AI team.',
            url: `${BASE_URL}/blog`,
            mainEntity: {
                '@type': 'ItemList',
                itemListElement: posts.map((post, index) => {
                    const isAbsoluteUrl = post.image.startsWith('http');
                    return {
                        '@type': 'ListItem',
                        position: index + 1,
                        url: `${BASE_URL}${post.slug}`,
                        name: post.title,
                        image: isAbsoluteUrl ? post.image : `${BASE_URL}${post.image}`,
                    };
                }),
            },
        };

        const script = document.createElement('script');
        script.type = 'application/ld+json';
        script.setAttribute('data-bloglist-jsonld', 'true');
        script.textContent = JSON.stringify(jsonLd);
        document.head.appendChild(script);

        return () => {
            document.head.removeChild(script);
        };
    }, [posts]);
}
